import type { IconData } from '@stacksjs/iconify-core'

export const chatBubbleOvalNotificationFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M45.942 18.996A11.95 11.95 0 0 1 38 22c-6.627 0-12-5.373-12-12c0-3.045 1.134-5.826 3.004-7.942A22.6 22.6 0 0 0 24 1.5C11.574 1.5 1.5 11.574 1.5 24a22.4 22.4 0 0 0 2.858 10.983c-.943 2.496-1.828 5.378-2.407 8.257a2.305 2.305 0 0 0 2.807 2.71c2.751-.645 5.544-1.54 8.01-2.45A22.4 22.4 0 0 0 24 46.5c12.426 0 22.5-10.074 22.5-22.5a22.6 22.6 0 0 0-.558-5.004\"/><path fill=\"#2859c5\" d=\"M47 10a9 9 0 1 1-18 0a9 9 0 0 1 18 0\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default chatBubbleOvalNotificationFlat
